import { IconButton, styled, Typography } from '@mui/material';

export const StyledTitle = styled(Typography)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  width: '90%',
}));

export const StyledCloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  right: theme.spacing(1),
  top: theme.spacing(2),
  color: '#000',
}));